import { View, Text } from "react-native";
import { GridItem } from "ui/types/GridItem";

type Props = {
  title?: string;
  items: GridItem[];
  isNumberList?: boolean;
};

export default function KeyValueList({
  title,
  items,
  isNumberList = false,
}: Props) {
  return (
    <View>
      {title ? (
        <Text className="text-typography-900 capitalize font-semibold text-lg mb-4">
          {title}
        </Text>
      ) : null}
      <View className="flex flex-col gap-y-4">
        {items.map((item, index) => (
          <View key={index} className="flex flex-col">
            <Text
              className={` capitalize ${isNumberList ? "font-base text-typography-500" : "font-semibold"}`}
            >
              {isNumberList ? `${index + 1}. ${item.label}` : item.label}
            </Text>
            <Text className="text-typography-900 capitalize mt-1">
              {item.value}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}
